import { useAllCalls } from '../../hooks/api/useCalls';
import { NoCallsCard } from '../../components/common/call-history/no-calls-card';
import { HistoryCallCard, HistoryCallCardSkeleton } from '../../components/common/call-history/history-call-card';
import { FormBlock } from '../../components/modals/settings-modal/form-block';
import { PageHeader } from '../../components/modals/settings-modal/page-header';
import useAuth from '../../hooks/utils/useAuth';

export const CallHistory = () => {
  const { user, isLoading: userIsLoading } = useAuth();
  const { data: calls, isLoading: isCallsLoading } = useAllCalls(user?.caller_role_id);

  return (
    <div className="p-6">
      <PageHeader header="Call history" />
      <div className="mt-6 space-y-4">
        {!(userIsLoading || isCallsLoading) ? (
          calls?.length ? (
            calls?.map((call) => (
              <FormBlock key={call.id}>
                <HistoryCallCard call={call} />
              </FormBlock>
            ))
          ) : (
            <NoCallsCard className="mx-auto mt-14 w-[300px]" />
          )
        ) : (
          [...Array(5).keys()].map((index) => (
            <FormBlock key={index}>
              <HistoryCallCardSkeleton />
            </FormBlock>
          ))
        )}
      </div>
    </div>
  );
};
